<template>
  <div>
    <wc-section-title title='Payroll'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'settings-base',
  computed: {
    menu () {
      return [
        {
          title: 'Payroll Dashboard',
          icon: this.$store.state.icons.modules.payroll.icon,
          route: { name: 'PayrollDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Payroll Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
